/* LOH cart-rain — plays when the cart drawer opens. Config comes from data-* on .cart-rain
   (rendered by snippets/cart-rain.liquid from theme settings). The drawer's inner HTML is
   replaced on every cart update, so nothing is cached on the container itself. */
(function () {
  if (window.__lohCartRain) return;
  window.__lohCartRain = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var preloaded = false;
  var log = (window.__lohRainLog = window.__lohRainLog || []);
  function note(msg) { if (log.length > 60) log.shift(); log.push((Date.now() % 1000000) + ' ' + msg); }

  function readConfig(el) {
    var images = [];
    try { images = JSON.parse(el.getAttribute('data-images') || '[]'); } catch (e) {}
    images = images.map(function (i) {
      return typeof i === 'string' ? { src: i, scale: 1 } : { src: i.src, scale: parseFloat(i.scale) || 1 };
    }).filter(function (i) { return i.src; });
    return {
      images: images,
      count: parseInt(el.getAttribute('data-count'), 10) || 12,
      size: parseInt(el.getAttribute('data-size'), 10) || 96,
      duration: parseFloat(el.getAttribute('data-duration')) || 6,
      frequency: el.getAttribute('data-frequency') || 'every_open',
      onEmpty: el.getAttribute('data-on-empty') === 'true'
    };
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function preload(images) {
    if (preloaded) return; preloaded = true;
    if (navigator.connection && navigator.connection.saveData) return;
    images.forEach(function (im) { var i = new Image(); i.decoding = 'async'; i.src = im.src; });
  }

  function rain(drawer) {
    var el = drawer.querySelector('.cart-rain');
    if (!el) { note('skip: no .cart-rain in drawer (' + drawer.className + ')'); return; }
    if (reduced) { note('skip: reduced motion'); return; }
    var c = readConfig(el);
    if (!c.images.length) { note('skip: no images'); return; }
    if (!c.onEmpty && drawer.classList.contains('is-empty')) { note('skip: is-empty'); return; }
    if (c.frequency === 'once_per_session') {
      try {
        if (sessionStorage.getItem('loh-cart-rain')) { note('skip: once per session'); return; }
        sessionStorage.setItem('loh-cart-rain', '1');
      } catch (e) {}
    }
    if (el.getAttribute('data-running')) { note('skip: already running'); return; }
    el.setAttribute('data-running', '1');
    el.innerHTML = '';

    // Measure against the drawer panel and the viewport: the container can read 0 mid-layout.
    var inner = drawer.querySelector('.drawer__inner');
    var w = Math.max(el.clientWidth, inner ? inner.clientWidth : 0);
    if (w < 120) w = Math.min(400, window.innerWidth || 400);
    var h = Math.max(el.clientHeight, inner ? inner.clientHeight : 0, window.innerHeight || 0, 600);
    note('rain: start w=' + w + ' h=' + h);
    var count = (window.innerWidth || 0) < 750 ? Math.min(c.count, 9) : c.count; // Dawn's mobile breakpoint
    var pool = shuffle(c.images.slice());
    var live = 0;

    for (var i = 0; i < count; i++) {
      var img = document.createElement('img');
      img.className = 'cart-rain__item';
      var pick = pool[i % pool.length];
      img.src = pick.src;
      img.alt = '';
      img.draggable = false;
      var size = Math.round(c.size * pick.scale * (0.7 + Math.random() * 0.7));
      var fall = (c.duration * (0.5 + Math.random() * 0.3)).toFixed(2);
      var delay = (Math.random() * c.duration * 0.6).toFixed(2);
      var r0 = Math.round(-25 + Math.random() * 50);
      var r1 = r0 + (Math.random() < 0.5 ? -1 : 1) * Math.round(30 + Math.random() * 110);
      var x = Math.round(Math.random() * Math.max(0, w - size));
      var sway = Math.round(-40 + Math.random() * 80);
      img.style.setProperty('--x', x + 'px');
      img.style.setProperty('--w', size + 'px');
      img.style.setProperty('--h', h + 'px');
      img.style.setProperty('--d', fall + 's');
      img.style.setProperty('--delay', delay + 's');
      img.style.setProperty('--r0', r0 + 'deg');
      img.style.setProperty('--r1', r1 + 'deg');
      img.style.setProperty('--sway', sway + 'px');
      live++;
      img.addEventListener('animationend', function () {
        this.remove();
        if (--live <= 0) el.removeAttribute('data-running');
      });
      el.appendChild(img);
    }
    // Safety: clear the running flag even if animationend never fires (tab hidden etc.)
    setTimeout(function () { el.removeAttribute('data-running'); }, (c.duration * 1.5 + 1) * 1000);
  }

  var lastRain = 0;
  function trigger(drawer) {
    if (!drawer) { note('trigger: no drawer'); return; }
    if (Date.now() - lastRain < 1000) { note('trigger: debounced'); return; }
    lastRain = Date.now();
    rain(drawer);
  }

  // Primary trigger: wrap Dawn's CartDrawer.open() so every open (cart icon, add-to-cart) fires,
  // independent of class-mutation timing. Small delay lets the drawer slide in first.
  function hookOpen() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var ctor = customElements.get('cart-drawer');
      var proto = ctor && ctor.prototype;
      if (!proto || proto.__lohRainHooked || typeof proto.open !== 'function') return;
      proto.__lohRainHooked = true;
      var orig = proto.open;
      proto.open = function () {
        var result = orig.apply(this, arguments);
        var self = this;
        note('hook: open() called');
        trigger(self);
        return result;
      };
    }).catch(function () {});
  }

  // Fallback trigger: watch the "active" class on the drawer node (re-attached if the node is replaced).
  var observed = null;
  function watch(drawer) {
    if (!drawer || drawer === observed) return;
    observed = drawer;
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) { note('observer: active added'); trigger(drawer); }
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    hookOpen();
    watch(document.querySelector('cart-drawer'));
    new MutationObserver(function () {
      var d = document.querySelector('cart-drawer');
      if (d && d !== observed) watch(d);
    }).observe(document.body, { childList: true });

    // Warm the image cache once the page is idle so the first open doesn't pop in late.
    var el = document.querySelector('.cart-rain');
    if (el) {
      var cfg = readConfig(el);
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 2500); };
      idle(function () { preload(cfg.images); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
